import React from 'react';
import "./Checkout.css";
import Subtotal from '../components/Subtotal';
import { useStateValue } from '../StateProvider';
import CheckoutProduct from '../components/CheckoutProduct';
import FlipMove from "react-flip-move";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { Avatar } from '@material-ui/core';

function Checkout() {
    const [{basket, user}, dispatch] = useStateValue();
    const vendorList = (name, link)=>(
        <div className="widgets__article">
            <div className="widget__articleLeft">
                <FiberManualRecordIcon />
            </div>
            <div className="widget__articleRight">
                <h4>{name}</h4>
                <a href={link}>Link to landing page</a>
            </div>
        </div>
    )
    const reviews = (name, message,image)=>(
        <div className="widgets__article">
            <div className="widget__articleLeft">
                <Avatar >{image}</Avatar>
            </div>
            <div className="widget__articleRight">
                <h4>{name}</h4>
                <p>{message}</p>
            </div>
        </div>
    )
    return (
        <div className="checkout">
            <div className="checkout__left">
                <img className="checkout__ad" src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg" alt="ad"/>
                <div>
                    <h3>Hello, {user?.email}</h3>
                    <h2 className="checkout__title">
                        Your Shopping Basket
                    </h2>
                    
                    <div className="Checkout__items">
                     <div className="Empty__space">
                         <h2>WHAT OUR CUSTOMERS ARE SAYING</h2>
                         {reviews("Gideon", "This is such an incredible app", "G")}
                         {reviews("Desmond", "Unmatched User Experinece", "D")}
                         {reviews("Shaibu", "Awesome Customer Service", "S")}
                         {reviews("Seb", "Best ecommerce app so far", "S")}
                         {reviews("Arham", "This app is a game changer", "A")}

                     </div>
                     <div className="Real__items">
                     <FlipMove>
                    {basket?.map(item=>(
                        <CheckoutProduct
                            id={item.id}
                            title={item.title}
                            image={item.image}
                            price={item.price}
                            rating={item.rating}
                        />
                    ))}
                    </FlipMove>
                    </div>
                    </div> 
                    
                </div>
            </div>
            <div className="checkout__right">
                <Subtotal/>
                <div className="Vendors">
                    <h2>Popular Vendors In the City</h2>
                    {vendorList("Al Ahlia ", "https://www.luluhypermarket.com/en-ae/?rdacb=lhmae21abvt-04")}
                    {vendorList("MazoubDG", "OrderId:#23456532")}
                    {vendorList("Fahr Diaz", "VendoId:124554424")}
                    {vendorList("Rennes", "Email:amos@gmail.com")}
                    {vendorList("Sadiyaat Groceries", "Email:caleb@gmail.com")}
                      
                </div> 
            </div>
        </div>
    )
}

export default Checkout
